export function dedupe(sl: string[]): string[] {
    let s = new Set<string>(sl);
    let suggestedValues: string[] = [];
    s.forEach((v: string) => suggestedValues.push(v));
    return suggestedValues.sort((a, b) => a.localeCompare(b));
}
